import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.application.mouseX
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.color.cosineColor
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.Vector3
import com.github.chosamuel.kishibe.noise.simplex
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin
import kotlin.random.Random

fun main() {
}

var mouseMoved: Boolean = false
val seed = Random.nextInt(999)

val app = Application {
    Program {
        //CREATE GRAPH
        val g = Graph()
        val resolution = 1500
        val stepSize = PI*0.075
        repeat(resolution){
            val radius = it * 0.01
            val angle = stepSize * it
            val x = cos(angle) * radius  + (getWidth()*0.5)
            val y = sin(angle) *  radius + (getHeight()*0.5)
            g.nodes.add(Point( Vector2(x,y) ))
            if(it == 0){
                g.cnx.add(mutableListOf(it+1,resolution-1))
            } else if (it == resolution - 1){
                g.cnx.add(mutableListOf(it-1,0))
            } else {
                g.cnx.add(mutableListOf(it-1,it+1))
            }
        }

        Draw { //MAIN DRAW LOOP
            if(!mouseMoved){
                mouseMoved = mouseX > 0
            }
            g.nodes.forEachIndexed { i, it->
                val rOff = simplex(i*0.15 + frameCount*0.01,frameCount*0.015,0.0)
                val percent = i.toDouble() / resolution.toDouble()
                it.pigment = cosineColor(
                    i * 0.001 + frameCount * 0.006 + rOff,
                    Vector3(0.5),
                    Vector3(0.5),
                    Vector3(1.0,0.7,0.4),
                    Vector3(0.0,0.15,0.2)
                )
                val radius = i * 0.25 + (rOff * 100 * percent)
                val angle = stepSize * i + (frameCount* 0.005)
                val x = cos(angle) * radius  + (getWidth()*0.5)
                val y = sin(angle) *  radius + (getHeight()*0.5)
                it.pos = Vector2(x,y)
            }

            val x = simplex(seed*1.0, frameCount*0.01,0.0)
                .let { it * 0.5 + 0.5 }
                .let{ it * getWidth() }
            val y = simplex(0.0,seed*1.0, frameCount*0.01)
                .let { it * 0.5 + 0.5 }
                .let{ it * getHeight() }
            val cursor = Vector2(x,y)

            clear(0.0)
            g.update(cursor)
            drawGraphAsLine(g)

        }
    }
}